import SignUpForm from "../../Components/Forms/SignUpForm";

const SignUp = () => {
  return (
    <div className="flex flex-col items-center bg-gray-100 min-h-screen">
        <SignUpForm />
    </div>
  );
};

export default SignUp;
